import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getIsPartnerOnboarded } from '@perpay-web/authentication/selectors';
import CardOnboardingSwitcher from '@perpay-web/fintech/components/screens/CardOnboardingSwitcher/CardOnboardingSwitcher';
import { cardOnboardingSwitcherDataModule } from '@perpay-web/fintech/dataModules/composed/cardOnboardingSwitcher';

const CardOnboardingSwitcherContainer = () => {
    const dispatch = useDispatch();

    const isLoading = useSelector(
        cardOnboardingSwitcherDataModule.getIsLoadingOrUnrequested,
    );
    const isPartnerOnboarded = useSelector(getIsPartnerOnboarded);

    const onMount = useCallback(() => {
        dispatch(cardOnboardingSwitcherDataModule.dataRequest());
    }, [dispatch]);

    return (
        <CardOnboardingSwitcher
            isLoading={isLoading}
            isPartnerOnboarded={isPartnerOnboarded}
            onMount={onMount}
            onUnmount={() => {
                dispatch(cardOnboardingSwitcherDataModule.dataReset());
            }}
        />
    );
};

export default CardOnboardingSwitcherContainer;
